import { FC, useState, useRef, useEffect } from "react";
import ProfileButton from "@/components/ui/Profile/profile-button";
import { WalletIcon, TransferIcon, ReferralsIcon, LogoutIcon } from "./profile-icons";
import { Link } from "react-router-dom";
import { createModalHelpers } from "@stores/unified-modal.store";
import WalletAddress from "@pages/Profile/components/WalletAddress";
import { useWallet } from "@stores/wallet.store";

const routes = [
    { label: "My Wallet", icon: WalletIcon, path: "/profile" },
    { label: "Transfer", icon: TransferIcon, modal: "transfer" },
    { label: "Refferals", icon: ReferralsIcon, modal: "referal" },
    { label: "Logout", icon: LogoutIcon, modal: "disconnect" },
];

const ProfileMenu: FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const { openModal } = createModalHelpers();
    const isConnected = useWallet((state) => state.isConnected);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="relative inline-block text-left z-100 justify-self-end w-fit" ref={dropdownRef}>
            <ProfileButton onClick={() => setIsOpen((prev) => !prev)} />
            {isOpen && (
                <div className="absolute right-0 mt-2 origin-top-right bg-card-solid/80 rounded-3xl backdrop-blur-lg border border-muted-foreground shadow-lg z-20 w-fit">
                    <div className="p-2 flex flex-col gap-2 w-fit">
                        <div className="min-w-50 h-20 bg-primary/30 rounded-2xl border border-primary/60 mb-2">
                            {isConnected ? (
                                <WalletAddress showSelectModal={() => openModal("select")} small plain />
                            ) : (
                                ""
                            )}
                        </div>
                        {routes.map((route) => {
                            const content = (
                                <>
                                    <span className="text-muted-foreground rounded-sm flex size-6 bg-gray-500 items-center justify-center">
                                        {route.icon({ width: 18, height: 18, opacity: 0.8 })}
                                    </span>
                                    <span>{route.label}</span>
                                </>
                            );

                            const className =
                                "flex items-center justify-start  hover:bg-muted border border-transparent hover:border-muted gap-2 cursor-pointer rounded-xl p-2 w-full text-left transition-colors duration-200 ease-in-out ";

                            if (route.path) {
                                return (
                                    <Link
                                        to={route.path}
                                        key={route.path}
                                        className={className}
                                        onClick={() => setIsOpen(false)}
                                    >
                                        {content}
                                    </Link>
                                );
                            } else if (route.modal) {
                                return (
                                    <button
                                        key={route.modal}
                                        className={className}
                                        onClick={() => {
                                            openModal(route.modal as any);
                                            setIsOpen(false);
                                        }}
                                    >
                                        {content}
                                    </button>
                                );
                            }
                            return null;
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfileMenu;
